import { MyleMenuNavPathLookup } from "@/Common/Models/MyleMenu/enums/MyleMenuNavPathLookup";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseStore } from "@/Common/Stores/BaseStore";

let defaultInstance: NavStore;

class NavStore extends BaseStore {
    public lastUnauthorizedPath: string;

    constructor() {
        super();
        this.ClientDispatchToken = LocalEventDispatcher.register((request: LocalEvent) => {
            var fireEmit = true;
            switch (request.Operation) {
                case LocalOperations.Router.Route_Change:
                    this.lastUnauthorizedPath = request.Get<string>("deniedPath");
                    break;
                default:
                    fireEmit = false;
                    break;
            }
            if (fireEmit)
                this.EmitChangeToListeners();
        });
    }

    public static createSingleton(): NavStore {
        return this.createStoreSingleton(defaultInstance, () => defaultInstance = new NavStore());
    }

    public convertAndSetCurrentTabNameFromRoutePath(pathName: string): void {
        // when logging back in after timeout, paths get a trailing slash
        // to title case + Tab append ensures naming convention matches that defined the name of the variable and not the string value in MyleMenuNavPathLookup.
        let formattedPathName = `${pathName.replace("/", "").toTitleCase()}Tab`;

        if (!IsNullOrUndefined(MyleMenuNavPathLookup[formattedPathName])) {
            sessionStore.activeMYLEMenuTab = MyleMenuNavPathLookup[formattedPathName];
        }
    }
}

export { NavStore, defaultInstance as navStore };
